import { createApp } from 'vue'

import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

import PrimeVue from 'primevue/config'
import VueEasyLightbox from 'vue-easy-lightbox'

import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueApexCharts from 'vue3-apexcharts'
import Tooltip from 'primevue/tooltip'

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import 'primeicons/primeicons.css'
import 'primevue/resources/primevue.min.css'
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'primeflex/primeflex.css'
import Print from "vue3-print-nb";

import { PRIMEFACES_LOCALE_PT_BR } from '@/constants/locale.constants.js'

import 'typeface-roboto/index.css'

import './assets/sass/style.scss'

library.add(fas)

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

const app = createApp(App)

app.directive('tooltip', Tooltip)

app.component('FontAwesomeIcon', FontAwesomeIcon)

app.use(router)
app.use(store)
app.use(VueAxios, axios)
app.use(PrimeVue, { locale: { ...PRIMEFACES_LOCALE_PT_BR } })
app.use(VueApexCharts)
app.use(VueEasyLightbox)
app.use(VueSweetalert2)
app.use(Print)

app.mount('#app')
